import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { isApiError } from '@/lib/api/errors'

export const sessionKey = ['session'] as const

/**
 * A 401 anywhere means the session ended (expired, signed out elsewhere, or
 * password changed). Drop cached data and let the auth guard redirect.
 */
function handleUnauthenticated(error: unknown) {
  if (isApiError(error) && error.isUnauthenticated) {
    queryClient.setQueryData(sessionKey, null)
  }
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: handleUnauthenticated }),
  mutationCache: new MutationCache({ onError: handleUnauthenticated }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        if (isApiError(error) && error.status >= 400 && error.status < 500) return false
        return failureCount < 2
      },
    },
    mutations: { retry: false },
  },
})
